import { useQuery } from "@tanstack/react-query";
import { fetchWithErrorHandling } from "../utils/service";

/**
 * Hook to perform search
 * @param {string} query - The search query
 * @param {Object} options - Search options (filters, pagination, etc.)
 * @param {boolean} enabled - Whether the query should be enabled
 */
export const useSearch = (query, options = {}, enabled = true) => {
  return useQuery({
    queryKey: ["search", query, options],
    queryFn: () => {
      if (!query || query.length <= 1) {
        return {
          data: {
            bookmarks: [],
            collections: [],
            tags: [],
            pagination: { total: 0 },
          },
        };
      }
      return fetchWithErrorHandling(
        `/v1/search?q=${encodeURIComponent(query)}&${new URLSearchParams(
          options
        )}`
      );
    },
    enabled: enabled && query && query.length > 1,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

/**
 * Hook to fetch search suggestions
 * @param {string} query - The search query
 * @param {boolean} enabled - Whether the query should be enabled
 */
export const useSearchSuggestions = (query, enabled = true) => {
  return useQuery({
    queryKey: ["search-suggestions", query],
    queryFn: () => {
      if (!query || query.length <= 1 || query.length >= 20) {
        return { data: [] };
      }
      return fetchWithErrorHandling(
        `/v1/search/suggestions?q=${encodeURIComponent(query)}`
      );
    },
    enabled: enabled && query && query.length > 1 && query.length < 20,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
